import { UntypedFormControl } from '@angular/forms';
export function validatorFileType(type: string): any {
  return (control: UntypedFormControl) => {
    const file = control.value;
    if (file) {
      const extension = file.name.split('.')[1].toLowerCase();
      if (type.toLowerCase() !== extension.toLowerCase()) {
        return {
          validatorFileType: true
        };
      }
      return null;
    }
    return null;
  };
}
export function validatorFileSize(size: number): any {
  return (control: UntypedFormControl) => {
    const file = control.value;
    if (file) {
      const sizeFile = (file as File).size;
      if (sizeFile > size) {
        return {
          validatorFileSize: true
        };
      }
      return null;
    }
    return null;
  };
}
